export enum OrderType {
  LIMIT = 'LIMIT',
  MARKET = 'MARKET',
}
